module.exports = __webpack_public_path__ + "img/500.4682461.svg";